const AUTH_TOKEN_STORAGE_KEY = "mcsportal_auth_token";
const BROWSER_INSTANCE_STORAGE_KEY = "mcsportal_browser_instance_id";

const getSessionStorage = () => {
  try {
    return window.sessionStorage;
  } catch (error) {
    return null;
  }
};

const getLocalStorage = () => {
  try {
    return window.localStorage;
  } catch (error) {
    return null;
  }
};

const createBrowserInstanceId = () => {
  if (
    typeof window !== "undefined" &&
    window.crypto &&
    typeof window.crypto.randomUUID === "function"
  ) {
    return window.crypto.randomUUID();
  }

  return `browser-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
};

// save JWT token in tab-scoped session storage
export const saveJWTTokenInCookie = (token, rememberMe) => {
  void rememberMe;
  const storage = getSessionStorage();

  if (!storage) {
    return;
  }

  storage.setItem(AUTH_TOKEN_STORAGE_KEY, token);
};

// remove JWT token from tab-scoped session storage
export const removeJWTTokenFromCookie = () => {
  const storage = getSessionStorage();

  if (!storage) {
    return;
  }

  storage.removeItem(AUTH_TOKEN_STORAGE_KEY);
};

// Get JWT token from tab-scoped session storage
export const getJWTTokenFromCookie = () => {
  const storage = getSessionStorage();
  const token = storage?.getItem(AUTH_TOKEN_STORAGE_KEY);

  return token ? `Bearer ${token}` : undefined;
};

// Get raw JWT token from tab-scoped session storage
export const getRawJWTTokenFromCookie = () => {
  const storage = getSessionStorage();
  return storage?.getItem(AUTH_TOKEN_STORAGE_KEY) || undefined;
};

// clear app auth data stored for the current browser tab
export const clearCookieData = () => {
  removeJWTTokenFromCookie();
};

export const getBrowserInstanceId = () => {
  const storage = getLocalStorage();

  if (!storage) {
    return undefined;
  }

  let browserInstanceId = storage.getItem(BROWSER_INSTANCE_STORAGE_KEY);

  if (!browserInstanceId) {
    browserInstanceId = createBrowserInstanceId();
    storage.setItem(BROWSER_INSTANCE_STORAGE_KEY, browserInstanceId);
  }

  return browserInstanceId;
};
